import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import ReactDOM from 'react-dom';
import styles from './dropdown-list.module.css';
import Checkbox from '../../checkbox/checkbox';
import { Chip } from '../../../chips';
import { XIcon } from '../../../../design';
import { getClickQuadrant, useBrowser } from '../../../../library';
function DropdownListItems(props) {
    var items = props.items, multiple = props.multiple, listRef = props.listRef, bottomQuadrant = props.bottomQuadrant;
    function onClickHandler(event, item) {
        if (multiple || item.disabled) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (item.disabled)
            return undefined;
        item.onClick();
        return undefined;
    }
    return (React.createElement("ul", { ref: listRef, className: classNames(styles.dropdownList, { bottomQuadrant: bottomQuadrant }) }, items.map(function (item) {
        var _a;
        var value = item.value, label = item.label, disabled = item.disabled, selected = item.selected, icon = item.icon;
        return (React.createElement("li", { key: value, className: classNames(styles.dropdownListItem, (_a = {}, _a[styles.disabled] = disabled, _a[styles.selected] = selected, _a)), onMouseDownCapture: function (event) { return onClickHandler(event, item); } }, !!multiple && !disabled ? (React.createElement(Checkbox, { id: value, clickablearea: "label", checked: selected, onChange: function (event) { return event.preventDefault(); } },
            !!icon && React.createElement("div", { className: styles.dropdownListItemIcon }, icon),
            React.createElement("span", { className: styles.dropdownListItemLabel }, label !== null && label !== void 0 ? label : value))) : (React.createElement(React.Fragment, null,
            !!icon && React.createElement("div", { className: styles.dropdownListItemIcon }, icon),
            React.createElement("span", { className: styles.dropdownListItemLabel }, label !== null && label !== void 0 ? label : value)))));
    })));
}
function SelectedDropdownListItems(_a) {
    var selectedItems = _a.selectedItems, multiple = _a.multiple;
    function onMouseDownCaptureHandler(event, item) {
        if (multiple) {
            event.preventDefault();
            event.stopPropagation();
        }
        item.onClick();
        return undefined;
    }
    return (React.createElement("ul", { className: styles.selectedDropdownList }, selectedItems.map(function (item) {
        var value = item.value, label = item.label, icon = item.icon, onClick = item.onClick;
        return (React.createElement("li", { key: value, className: styles.selectedDropdownListItem, onMouseDownCapture: function (event) { return onMouseDownCaptureHandler(event, item); } },
            React.createElement(Chip, { label: label !== null && label !== void 0 ? label : value, backgroundColour: "transparent", borderColour: "borders", colour: "text", variant: "tiny", onClick: onClick, startIcon: icon, endIcon: React.createElement(XIcon, { tone: "secondary" }) })));
    })));
}
export function DropdownList(props) {
    var _a, _b;
    var children = props.children, items = props.items, _c = props.large, large = _c === void 0 ? false : _c, _d = props.multiple, multiple = _d === void 0 ? false : _d, _e = props.dialogContained, dialogContained = _e === void 0 ? false : _e, selectedItems = props.selectedItems;
    var triggerRef = useRef(null);
    var listRef = useRef(null);
    var browser = useBrowser();
    var _f = useState(false), isOpen = _f[0], setIsOpen = _f[1];
    var _g = useState({}), dataPoints = _g[0], setDataPoints = _g[1];
    function setDropdownPosition() {
        if (!triggerRef.current)
            return;
        var trigger = triggerRef.current;
        var _a = trigger.getBoundingClientRect(), x = _a.x, y = _a.y, top = _a.top, bottom = _a.bottom, width = _a.width, left = _a.left;
        var quadrant = getClickQuadrant({ clientX: x, clientY: y });
        setDataPoints({ top: quadrant.y === 'top' ? bottom : top, width: width, left: left, isFlipped: quadrant.y === 'bottom' });
    }
    function onCloseHandler() {
        window.removeEventListener('scroll', setDropdownPosition);
        setIsOpen(false);
    }
    function onOpenHandler() {
        setDropdownPosition();
        window.addEventListener('scroll', setDropdownPosition);
        setIsOpen(true);
    }
    var _h = useState(undefined), triggerHeight = _h[0], setTriggerHeight = _h[1];
    useEffect(function () {
        var _a;
        setTriggerHeight((_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height);
    });
    useEffect(function () {
        setDropdownPosition();
    }, [triggerHeight]);
    var customStyles = {};
    if (browser === 'IOS') {
        customStyles = {
            position: 'absolute',
            width: dataPoints.width,
            top: dataPoints.isFlipped ? 0 : 42,
            transform: dataPoints.isFlipped ? "translateY(-100%)" : '',
        };
    }
    else {
        customStyles = {
            width: dataPoints.width,
            left: dataPoints.left,
            transform: dataPoints.isFlipped ? "translateY(calc(".concat(dataPoints.top, "px - 100%))") : "translateY(".concat(dataPoints.top, "px)"),
        };
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { zIndex: 10, display: browser === 'IOS' ? 'block' : 'contents', position: browser === 'IOS' ? 'relative' : undefined } },
            children({ triggerRef: triggerRef, open: isOpen, onOpenHandler: onOpenHandler, onCloseHandler: onCloseHandler, bottomQuadrant: dataPoints.isFlipped }),
            isOpen && (React.createElement(React.Fragment, null, browser === 'IOS' || dialogContained ? (React.createElement("div", { style: customStyles, className: classNames(styles.dropdownListWrapper, (_a = {}, _a[styles.bottomQuadrant] = dataPoints.isFlipped, _a)) },
                React.createElement(DropdownListItems, { items: items, large: large, multiple: multiple, listRef: listRef, bottomQuadrant: dataPoints.isFlipped }),
                multiple && !!selectedItems.length && (React.createElement(SelectedDropdownListItems, { selectedItems: selectedItems, multiple: multiple })))) : (ReactDOM.createPortal(React.createElement("div", { style: customStyles, className: classNames(styles.dropdownListWrapper, (_b = {}, _b[styles.bottomQuadrant] = dataPoints.isFlipped, _b)) },
                React.createElement(DropdownListItems, { items: items, large: large, multiple: multiple, listRef: listRef, bottomQuadrant: dataPoints.isFlipped }),
                multiple && !!selectedItems.length && (React.createElement(SelectedDropdownListItems, { selectedItems: selectedItems, multiple: multiple }))), window.document.body)))))));
}
